import Api from "@/api/stories-chapters.js";
import { ref, reactive, toRefs } from "vue";

export default function stories(id, storiesId, emit) {

    // Реактивные переменные
    const state = reactive({
        title: ref(""),
        description: ref(""),
        text: ref(""),
        author: ref(""),
        status: ref(null),
        order: ref(null),
        models: ref([]),
        statusOptions: ref([
            { value: 0, text: "Ознакаомительная" },
            { value: 1, text: "Полная" },
            { value: 2, text: "Не активная" },
        ]),
    });

    const createChapter = async () => {
        
        await Api.createModel({
            title: state.title,
            description: state.description,
            text: state.text,
            author: state.author,
            status: state.status,
            order: state.order,
            stories_id: storiesId
        });

        emit("created")
    };

    const updateChapter = async () => {
        await Api.updateModel(id, {
            title: state.title,
            description: state.description,
            text: state.text,
            author: state.author,
            status: state.status,
            order: state.order,
        });

        emit("updated")
    }


    const deleteChapter = async (id) => {
        let isDelete = confirm("Вы действительно хотите удалить главу?");

        if (isDelete === true) {
            await Api.deleteModel(id);
        }
    }


    const getChapter = async () => {
        let response = await Api.getModel(id);
        state.title = response.data.title;
        state.text = response.data.text;
        state.description = response.data.description;
        state.author = response.data.author;
        state.status = response.data.status;
        state.order = response.data.order;
    }

    const getChapters = async () => {
        let response = await Api.getModels({ fields: ['id', 'title'].join(',') });
        state.models = response.data;
    }

    return {
        ...toRefs(state), getChapters, getChapter, deleteChapter, updateChapter, createChapter,
    };
}
